exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".k-multiselect-wrap{padding:2px}", ""]);

// exports
